const FreteNoProdutoIconBranco = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg version="1.1" id="Camada_1" x="0px" y="0px" viewBox="0 0 3000 3000">
      <g>
        <path
          className="st0-fnp"
          d="M871.3,1188.3c-94.1-178.1-345.7-510.7-350.8-517.5c-71.7-96.3-145.9-190.7-223.9-282.1
		c-16.4-19.3-47.7-55.6-74.7-54.3c-7.1-0.6-13.4,0.5-19,3v-0.1c-17,7.4-28.5,26.8-38.5,49.7c-18.1,41.3-26.6,85.1-32.9,129.5
		c-29.6,209.7,35,349,35,349c-23.9,85.3-42.7,261.5-3.2,382c25.5,77.7,65.8,169.9,65.8,169.9c-3.7,16.5-11,53.5-11.9,70.2
		C205.8,1710,373,1812.3,391.6,1828.3c28.4,14.7,56.2,30.5,85.2,44c102.8,48,214.2,27.4,295.1-53.7c0.5-0.5,1-1.1,1.5-1.6v-0.1
		c90.1-96.3,143.5-210.8,160.5-340.8C947.2,1373.7,919.2,1278.9,871.3,1188.3z"
        />
        <g>
          <path
            className="st0-fnp"
            d="M1482.4,395c96.1,14.7,235.2,74.4,318.4,141.1c15.4,8.3,32.9,7.9,45.3-4.9c13.2-13.6,34.4-75.1,38.7-102.6
			c10.6-59.2,14.6-86.8,12.2-145.5c-4.7-53.7-9.6-83.8-24.1-140.7c-9.5-37.7-33.5-45.2-72.9-41.5c-76,7-125.3,22.7-196.3,65.9
			c-60.8,37-126,119.7-135.3,187.2C1465.4,376,1462,386.5,1482.4,395z"
          />
          <g>
            <path
              className="st0-fnp"
              d="M2844.9,1568.8c-39.5-143.5-70.1-210.7-145.6-338c-24.7-41.7-75.8-122.1-96.6-149.8
				c-29.6-39.2-35.5-27.1-81.8-8.8c-13.3,5.2-88.5,55.5-123,88c-86.1,80.9-75.8,89.6-127.8,53.4c-34.8-24.2-157.4-133.4-206.1-195.7
				c-84.5-108-137.9-221.8-218.5-332.5c-27.8-38.2-81-103.3-120-131.4c-88.4-63.6-173.1-91.1-281-107c-95.3-14-190.6,3-285,18.1
				c-58.8,9.4-115.8,26.6-172.3,46c-7.5,2.6-15.6-1.8-17.5-9.5c-18.4-73.6-54.6-132-84.5-157.3c-88.4-74.5-128.7-77.8-228.1-110.9
				c-54.6-18.2-81.5-23.3-105.2,43c-11.8,32.9-25.8,64.3-29.4,224.6c-0.4,17.5,0.2,34.6,1.4,51c9,11.9,17.9,23.8,26.8,35.7
				c5.8,7.7,289.6,382.9,395.7,583.7c54,102.2,85.6,209.1,70.6,324.6c-19.1,146.7-79.4,275.8-181.1,384.5v0.1
				c-0.6,0.6-1.1,1.2-1.7,1.8c-91.3,91.5-206.7,121.4-324.1,86.8c-19.8-5.8-36.9-18.2-55.1-27.9c96.3,270.4,241.7,474.4,477.1,651.2
				c249.9,187.7,529,290.8,840.2,306c185.7,9,364.1-28.8,537.5-93.2c110.7-41.1,254.7-145.6,330.6-238.1
				c148.7-181.3,215.9-331.3,231.5-571.8C2880.3,1865.2,2879.6,1694.8,2844.9,1568.8z M1318.6,1924.7
				c-109.2,26.3-225.6-68-259.8-210.7c-34.3-142.6,26.4-279.5,135.6-305.8c109.2-26.3,225.6,68,259.8,210.7
				S1427.8,1898.4,1318.6,1924.7z M2314,2181.9c-9.7,47.1-89.3,112.7-137.8,113.5c-35.4,0.6-56.1-26.3-46.8-60.8
				c12.2-45.1,86.6-106.5,133.1-109.7C2298.5,2122.4,2321.1,2147.4,2314,2181.9z"
            />
          </g>
        </g>

        <ellipse
          transform="matrix(0.9723 -0.2338 0.2338 0.9723 -354.4514 339.847)"
          className="st0-fnp"
          cx="1256.2"
          cy="1665"
          rx="126.8"
          ry="165.7"
        />
      </g>
    </svg>
  );
};

export default FreteNoProdutoIconBranco;
